import { isEmpty, isEqual, find, has } from 'lodash';
import {
  UPPER_THRESHOLD,
  DEFAULT_LOW_BAL,
  DEFAULT_HIGH_BAL,
  DEFAULT_TRANSACTION_BAL,
  FIX_DECIMAL_BY_TWO,
} from '../constants/StringConstants';
import { isTransactionMethodEnabled } from '../utils/TransactionMethods';

export const getAlertAccountData = (bulkBalanceAlerts, accountID, alertType) => {
  const alerts = find(bulkBalanceAlerts.get('bulkBalanceAlerts').account_alerts, {
    account_id: accountID,
  });
  const defaultBalance = alertType === UPPER_THRESHOLD ? DEFAULT_HIGH_BAL : DEFAULT_LOW_BAL;
  const defaultAlert = { enabled: false, amount: { value: defaultBalance } };
  if (!isEmpty(alerts)) {
    const alertBalance = find(alerts.alerts, (alert) => {
      return has(alert, alertType);
    });
    if (alertBalance) {
      return alertBalance[alertType];
    }
  }
  return defaultAlert;
};
export const getProjectionData = (bulkProjectionAlert) => {
  const projectionAlert = bulkProjectionAlert.get('bulkProjectionAlert');
  if (!isEmpty(projectionAlert.external_notifications)) {
    return projectionAlert;
  }
  return false;
};
export const getTransactionAccountData = (alerts, alertType) => {
  let defaultTransactionAlert = {
    amount: {
      value: DEFAULT_TRANSACTION_BAL,
      currency: 'GBP',
    },
    enabled: false,
  };
  if (alertType === 'crossborder') {
    defaultTransactionAlert = {
      enabled: false,
    };
  }
  if (!isEmpty(alerts) || !isEmpty(alerts.alertType)) {
    const alertBalance = find(alerts, (alert) => {
      return has(alert, alertType);
    });
    if (alertBalance) {
      return alertBalance[alertType];
    }
  }
  return defaultTransactionAlert;
};
export const isButtonDisabled = (amount, defaultAmount) => {
  if (isEqual(defaultAmount.toFixed(FIX_DECIMAL_BY_TWO).toString(), amount)) {
    return false;
  }
  return !isEmpty(amount);
};
export const showAmountValidationError = (amount) => {
  return isEmpty(amount) || parseFloat(amount) === 0;
};
export const checkIsIncomingTrasactionEnabled = (incomingTransactionAlerts) => {
  return (
    incomingTransactionAlerts &&
    getTransactionAccountData(incomingTransactionAlerts, 'amount').enabled
  );
};
export const checkIsTransactionEnabled = (
  transactionAlerts,
  transactionAlertMethods,
  incomingTransactionAlerts
) => {
  if (transactionAlerts) {
    const amountTransactionAlerts = getTransactionAccountData(transactionAlerts, 'amount');
    const abroadTransactionAlerts = getTransactionAccountData(transactionAlerts, 'crossborder');
    const transactionAlertEnabled = isTransactionMethodEnabled(transactionAlertMethods);
    return (
      checkIsIncomingTrasactionEnabled(incomingTransactionAlerts) ||
      amountTransactionAlerts.enabled ||
      abroadTransactionAlerts.enabled ||
      transactionAlertEnabled
    );
  }
  return false;
};
export const getTransactionAmountContent = (isSMEUser, content) => {
  return {
    transactionAmountEnableText: isSMEUser
      ? content.transactionAmountEnableTextSME
      : content.transactionAmountText,
    trasactionAmountDisableText: isSMEUser
      ? content.transactionAmountToggleTextSME
      : content.transactionAmountToggleText,
  };
};
